export const DEFAULT_TRIGGER = 'click';
